'use strict';
import Modal from '@jsclasses/modal-class';
import { initSignUpForm } from '@jscheckout/confirmation/fastSignUp';

// Init
document.addEventListener('DOMContentLoaded', function () {
  // Initialize modals
  Modal.initElements('cart');

  // Initialize sign up form
  initSignUpForm();
});
